/**
 * useFormDraft Hook
 *
 * Draft/cache system is disabled. Forms submit directly to the API.
 */

import { useCallback } from 'react';

/**
 * @param {string} formKey - Unique identifier for the form (unused, caching disabled)
 * @param {number} autoSaveDelay - Unused, caching disabled
 * @returns {object} - Draft utilities (all no-ops)
 */
const useFormDraft = (_formKey, _autoSaveDelay = 1000) => {
  // No-op: caching disabled, forms submit directly to the API
  const autoSave = useCallback(() => {}, []);
  const loadDraftData = useCallback(async () => null, []);
  const clearDraft = useCallback(async () => {}, []);
  const clearDraftOnSuccess = useCallback(async () => {}, []);

  const handleSubmitWithDraft = useCallback(async (submitFunction, data) => {
    return await submitFunction(data);
  }, []);

  const getFormattedTimestamp = useCallback(() => '', []);

  return {
    hasDraftData: false,
    isDraftLoaded: false,
    draftTimestamp: null,
    autoSave,
    loadDraftData,
    clearDraft,
    clearDraftOnSuccess,
    handleSubmitWithDraft,
    getFormattedTimestamp,
  };
};

export default useFormDraft;
